import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[abxAriaExpanded]',
})
export class AriaExpandedDirective {
  readonly abxAriaExpanded = input<boolean>(false);

  private readonly el = inject(ElementRef<HTMLElement>);

  constructor() {
    effect(() => {
      this.el.nativeElement.setAttribute('aria-expanded', String(this.abxAriaExpanded()));
    });
  }
}
